const VIDEO_SELECTOR = '.main-collection__grid-banner-video';
const observedVideos = new WeakSet();

const playIfVisible = (video) => {
  video.muted = true;
  video.play().catch(() => {});
};

const observeVideo = (video, observer) => {
  if (observedVideos.has(video)) return;
  observedVideos.add(video);
  video.muted = true;
  observer.observe(video);
};

const initCollectionBannerVideos = (root = document) => {
  if (typeof IntersectionObserver !== 'function') return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const video = entry.target;
        if (!(video instanceof HTMLVideoElement)) continue;

        if (entry.isIntersecting) {
          playIfVisible(video);
        } else {
          video.pause();
        }
      }
    },
    { threshold: 0.1 }
  );

  if (root instanceof HTMLVideoElement) {
    observeVideo(root, observer);
  } else if (root.querySelectorAll) {
    root.querySelectorAll(VIDEO_SELECTOR).forEach((video) => observeVideo(video, observer));
  }
};

initCollectionBannerVideos();

document.addEventListener('shopify:section:load', (event) => {
  initCollectionBannerVideos(event.target);
});

if (typeof MutationObserver === 'function' && document.body) {
  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) initCollectionBannerVideos(node);
      }
    }
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
}
